import type { SortOptions } from './sort-info.type'
import { z } from '../utils/zod-extend'

export const paginationModes = ['offset', 'cursor'] as const
export type PaginationMode = typeof paginationModes[number]

export const paginationModeSchema = z.object({
  paginationMode: z.enum(paginationModes).optional(),
})
export type PaginationModeQuery = z.infer<typeof paginationModeSchema>

export const cursorPaginationParamSchema = z.object({
  before: z.string().optional(),
  after: z.string().optional(),
  per: z.number().optional(),
})
export type CursorPaginationQuery = z.infer<typeof cursorPaginationParamSchema>

export const cursorPageInfoSchema = z.object({
  hasNextPage: z.boolean(),
  hasBeforePage: z.boolean(),
  startCursor: z.string().nullable(),
  endCursor: z.string().nullable(),
})
export type CursorPageInfo = z.infer<typeof cursorPageInfoSchema>

export const cursorConditionSchema = z.object({
  cursor: cursorPaginationParamSchema.optional(),
})
export type CursorPaginationOptions = z.infer<typeof cursorConditionSchema>

export const offsetPaginationParamSchema = z.object({
  page: z.coerce.number().optional(),
  per: z.coerce.number().optional(),
})
export type OffsetPaginationQuery = z.infer<typeof offsetPaginationParamSchema>

export const offsetPageInfoSchema = z.object({
  page: z.number(),
  per: z.number(),
  total: z.number(),
})
export type OffsetPageInfo = z.infer<typeof offsetPageInfoSchema>

export const offsetPagingCondition = z.object({
  pageInfo: offsetPaginationParamSchema.optional(),
})
export type OffsetPaginationOptions = z.infer<typeof offsetPagingCondition>

export type PageInfo = CursorPageInfo | OffsetPageInfo

export type OffSetPaginationAndSortOptions = OffsetPaginationOptions & SortOptions
